module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isString.js
// module id = 59
// module chunks = 34471704633725 35783957827783 216468464745311